module.exports = __webpack_public_path__ + "static/media/metaHorizon.09758a9f.png";